import { render, staticRenderFns } from "./WaitinglistTable.vue?vue&type=template&id=580f9907"
import script from "./WaitinglistTable.vue?vue&type=script&lang=js"
export * from "./WaitinglistTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports